import { apiClient } from './api.client';

export const reportService = {
  /**
   * Get contribution report
   */
  async contributions() {
    const response = await apiClient.GET('/reports/contributions');
    if (response.error) throw new Error('Failed to fetch contribution report');
    return response.data || {};
  },

  /**
   * Get financial report (board only)
   */
  async financial() {
    const response = await apiClient.GET('/reports/financial');
    if (response.error) throw new Error('Failed to fetch financial report');
    return response.data || {};
  },

  /**
   * Get loan report
   */
  async loans() {
    const response = await apiClient.GET('/reports/loans');
    if (response.error) throw new Error('Failed to fetch loan report');
    return response.data || {};
  },

  /**
   * Get summary report
   */
  async summary() {
    const response = await apiClient.GET('/reports/summary');
    if (response.error) throw new Error('Failed to fetch summary report');
    return response.data || {};
  }
};